/* eslint-disable no-unused-vars */
/* eslint-disable react/display-name */
import React from 'react'
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { message } from 'antd'
import JcTmpErrorDialog, {
  isErrorContains,
  isErrorContainsTmpError,
} from 'core/component/JcTmpErrorDialog'
// const onCell = _ => ({ style: { paddingTop: '10px', paddingBottom: '10px' } })
// const onHeaderCell = _ => ({ style: { backgroundColor: '#eee' } })

const CardErrorDialog = ({
  visible,
  errors,
  action,
  closeErrorPrompt,
  setShowEditDialog,
  retrieveData,
  allowRetrieve = true,
}) => {
  const onOk = _ => {
    const err = errors.find(f => f.severity === '1')
    if (err === undefined) {
      if (action === 'delete' || action === 'D')
        message.info('Data deleted successfully.')
      else {
        message.info('Data saved successfully.')
      }
      allowRetrieve && retrieveData({})
    }
    if (!isErrorContainsTmpError(errors))
      setShowEditDialog && setShowEditDialog(false)
    closeErrorPrompt()
  }

  return (
    <JcTmpErrorDialog
      visible={visible}
      closeErrorPrompt={onOk}
      errors={errors.map(d => ({
        ...d,
        errorMessage: d.errorMessage ? d.errorMessage : d.error,
      }))}
    />
  )
}

export default CardErrorDialog
